import React from 'react';
import { NavLink } from 'react-router-dom';
import { isInternalURL, toBackendLang } from '@plone/volto/helpers';
import config from '@plone/volto/registry';
import { keys, isEmpty, map, filter } from 'lodash';
import { Dropdown } from 'semantic-ui-react';
import { UniversalLink, Image } from '@plone/volto/components';
import { Icon } from '../';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown  } from '@fortawesome/free-solid-svg-icons';


const NavItem = ({ item, lang, mobile }) => {
  const { settings } = config;
  const subItems = item.items

  if (isInternalURL(item.url) || item.url === '') {
    return (
      <>
      {(!isEmpty(item.items) && !mobile ) ? (
        <Dropdown 
          text={item.title} 
          inline 
          basic
          item
          >          
          <Dropdown.Menu className="mnPrincipal__second">
            {map(subItems, (item, index) => (
              <Dropdown.Item key={index}>               
                <NavLink
                  to={item.url === '' ? '/' : item.url}
                  key={item.url}
                  className={`item ${ (item.header_style_type === "header-style-three") && 'item--company'} `}
                  exact={
                    settings.isMultilingual
                      ? item.url === `/${toBackendLang(lang)}`
                      : item.url === ''
                  }
                  style={{ '--ecc-company-menu-color': (item?.content_color ? item.content_color : 'transparent') }}
                >
                  {item.content_icon && (
                    <Icon name={item.content_icon} />
                  )}

                  {item.header_style_type === "header-style-three" ? (
                    <>                      
                      {item.image_field && (
                        <Image
                          item={item}
                          alt={item.title}
                          className="" 
                          loading="lazy"
                          sizes="(max-width: 991px) 100vw, (max-width: 1599px) 33vw, 30rem"
                          />                  
                      )}
                      {item.pretitle && <span className='item--company__title'>{item.pretitle}</span> }
                    </>
                  ) : (
                   <>{item.title}</>
                  )}

                </NavLink>
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      ) : (
        <NavLink
          to={item.url === '' ? '/' : item.url}
          key={item.url}
          className="item"
          activeClassName="current"
          exact={
            settings.isMultilingual
              ? item.url === `/${toBackendLang(lang)}`
              : item.url === ''
          }
        >
          {item.title}
        </NavLink>
      )}
      </>
    );
  } else {
    return (
      <a
        href={item.url}
        key={item.url}
        className="item"
        rel="noopener noreferrer"
        target={settings.openExternalLinkInNewTab ? '_blank' : '_self'}
      >
        {item.title}
        {settings.openExternalLinkInNewTab && ( <span class="visually-hidden"><FormattedMessage id="Opens in new window" defaultMessage="Opens in new window"  /></span> )}
      </a>
    );
  }
};

export default NavItem;
